module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/en_2-0419d0273e39aa3ac268b08400b0314e.jpg";